module.exports = __webpack_public_path__ + "assets/fdc6a5f327272207608bc1d0f0556a08.mp3";